import { debounce } from '../helper/functions';
import { onKeyUpEscape } from '../helper/functions';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form') || this;

    this.categoryFilters = document.querySelectorAll('.filter-value');
    this.categoryFilters.forEach((filter) => {
      let value = filter.innerHTML;
      let newValue = value.replace(/\d+/g, '');
      filter.textContent = newValue;
    });

    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.renderSectionFromFetch(url, event);

      // Cached data is broken, just going to force a request on filter update
      // FacetFiltersForm.filterData.some(filterDataUrl)
      //   ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      //   :
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log(url);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        console.log('load from fetch');
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDropdownElements = parsedHTML.querySelectorAll(
      //'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDropdownElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDropdownElements).find(matchesIndex);

    this.categoryFilters = document.querySelectorAll('.filter-value');
    this.categoryFilters.forEach((filter) => {
      let value = filter.innerHTML;
      let newValue = value.replace(/\d+/g, '');
      filter.textContent = newValue;
    });

    facetsToRender.forEach((element) => {
      const facet = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      const categoryFilters = document.querySelectorAll('.filter-value');
      categoryFilters.forEach((filter) => {
        let value = filter.innerHTML;
        let newValue = value.replace(/\d+/g, '');
        filter.textContent = newValue;
      });
      facet.innerHTML = element.innerHTML;
      if (facet.tagName === 'DROP-DOWN') {
        facet.bindEvents();
      }
    });

    console.log(FacetFiltersForm);

    document.querySelectorAll(
      //'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    ).innerHTML = facetDropdownElements.innerHTML;

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // Open all drop-down accordions with 'keepOpen' attribute after re-rendering
    const dropdowns = document.querySelectorAll('drop-down[keepOpen]');
    dropdowns.forEach((dropdown) => {
      dropdown.open();
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    // Check if active filters and show/hide the Apply & Clear Filters buttons
    const clearFiltersButton = document.querySelector('.desktop__clearfilters');
    const activeFacets = document.querySelector('.active-facets');

    // Check if the url has a sort by param.
    const parsedUrl = new URL(window.location);
    const params = new URLSearchParams(parsedUrl.search);
    const hasSort = params.has('sort_by');

    if ((activeFacets && activeFacets.children.length > 0) || hasSort) {
      clearFiltersButton.classList.remove('hidden');
      clearFiltersButton.classList.add('flex');
    } else {
      clearFiltersButton.classList.remove('flex');
      clearFiltersButton.classList.add('hidden');
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      console.log(document.querySelector(selector));
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    // need to make this work with a menu drawer
    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    //document.querySelector('load-more').bindEvent();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    let newSearchParams = new URLSearchParams(formData).toString();
    if (newSearchParams.includes('filter.v.option') && !newSearchParams.includes('filter.v.availability')) {
      newSearchParams = newSearchParams + '&filter.v.availability=1';
    }
    return newSearchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    console.log('remove filter');
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

if (!customElements.get('facets-form')) {
  customElements.define('facets-form', FacetFiltersForm);
}

FacetFiltersForm.setListeners();

// Global Enter key handler for all facet checkboxes
document.addEventListener(
  'keydown',
  (event) => {
    if (event.key === 'Enter' && event.target.type === 'checkbox' && event.target.closest('form.facets')) {
      event.preventDefault();
      event.target.click();
    }
  },
  true
);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}

class FacetSort extends HTMLElement {
  constructor() {
    super();
    this.selectedOption = document.querySelector('.option[selected="selected"]');
    this.options = this.querySelectorAll('.option');
    const facetSort = this;

    const sortFilterForm = document.querySelector('facet-filters-form');

    this.options.forEach(function (option) {
      option.addEventListener('click', function (event) {
        document.querySelectorAll('.option').forEach(function (option) {
          console.log(option);
          option.classList.remove('text-brand-primary-100');
        });
        document.querySelector('select[name="sort_by"]').value = this.getAttribute('value');
        var event = new Event('change');
        sortFilterForm.querySelector('select').dispatchEvent(event);
        this.classList.add('text-brand-primary-100');
        sortFilterForm.onSubmitHandler(event);
      });
    });
  }
}

if (!customElements.get('facet-sort')) {
  customElements.define('facet-sort', FacetSort);
}
